import { QueryClientProvider } from '@tanstack/react-query';
import type { FC, ReactNode } from 'react';
import { queryClient } from '@/shared/lib/query-client';

interface QueryProviderProps {
  children: ReactNode;
}

/**
 * TanStack Query Provider
 *
 * App層の責務:
 * - QueryClientProvider でアプリケーション全体をラップ
 * - shared/lib の queryClient インスタンスを使用
 */
export const QueryProvider: FC<QueryProviderProps> = ({ children }) => {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};
